import * as React from "react";
import { useNavigate } from "@reach/router";
import { SummaryCard } from "kw/admin/components/SummaryCard";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";
import { Placeholder } from "kanopi-components/Placeholder";
import { ClaimSummarySection } from "kw/claims/components/ClaimSummarySection";
import { useEffect } from "react";
import { useClaims } from "kw/claims/hooks/useClaims";
import { ClaimStatusTypes } from "kw/api/zeus";
import { COLOR } from "baseui/badge";
import { Button, SIZE, KIND } from "kanopi-components/Button";
import { NoContentMessage } from "kw/components/NoContentMessage/NoContentMessage";
import { Block } from "kanopi-components/Block";

export const ClaimListingPage = () => {
  const { claims, loading, fetchClaims } = useClaims();

  useEffect(() => {
    fetchClaims();
  }, []);

  const navigate = useNavigate();

  const headingCaption = (claim: TClaim) => {
    let color;
    switch (claim?.statusType) {
      case ClaimStatusTypes.OPEN:
        color = COLOR.positive;
        break;
      case ClaimStatusTypes.CLOSED:
        color = COLOR.negative;
        break;
    }
    return { caption: claim?.statusTypeDisplay, captionColor: color };
  };

  return (
    <Placeholder loading={!claims || loading}>
      {claims?.length ? (
        <VerticalSpacer>
          {claims?.map((claim, index) => {
            return (
              <SummaryCard
                title={`Claim ${claim?.id}`}
                key={index}
                ctas={[
                  <Button
                    key={0}
                    size={SIZE.compact}
                    outlined={true}
                    kind={KIND.secondary}
                    onClick={() => navigate(`/claims/${claim?.id}`)}
                  >
                    View details
                  </Button>,
                ]}
                headerCaption={headingCaption(claim)}
              >
                <ClaimSummarySection claim={claim} />
              </SummaryCard>
            );
          })}
        </VerticalSpacer>
      ) : (
        <NoContentMessage message={"You haven't made any claims."} maxWidth="100%">
          <Button onClick={() => navigate("/claims/make-a-claim")}>Make a claim</Button>
        </NoContentMessage>
      )}
    </Placeholder>
  );
};
